window.MarketplaceApp = window.MarketplaceApp || {};

$(document).ready(function () {

    if ($('#places-container').length > 0 && $('#marketplacecalculation-city_pickup_code').length > 0) {
        MarketplaceApp.calculator = new MarketplaceCalculator();
    }

    $('#mapModal').on('show.bs.modal', function (e) {
        const triggerButton = $(e.relatedTarget);

        if (triggerButton && triggerButton.attr('id') === 'openMapModalButton') {
            const $body = $('body');
            const originalStyles = {
                height: $body.css('height'),
            };

            $body.css({
                height: 'auto',
            });
            window.scrollTo(0, 0);

            $body.off('hidden.bs.modal.scrollRestore');
            $body.on('hidden.bs.modal.scrollRestore', function () {

                $body.css({
                    height: '',
                });

                $body.off('hidden.bs.modal.scrollRestore');
            });
        }
    });
});
